// extracted by mini-css-extract-plugin
export default {"wrap":"style-wrap-kMGZT","inner":"style-inner-1nnvM","dismissButton":"style-dismissButton-3Y1pD"};